


















































import { defineComponent } from '@vue/composition-api'
// import { currentNode } from '@/assets/node'
import { getUnitValue } from '@/assets/util'
import { state } from './state'
// import { editWrapState } from '@/assets/render'

export default defineComponent({
  setup (p, ctx) {
    const handleResizeDown = (e: MouseEvent, dir: string) => {
      // const node = currentNode.value!
      state.startX = e.x
      state.startY = e.y
      state.dragging = true
      state.dir = dir
      // @ts-ignore
      const position = ctx.parent.position
      state.width = getUnitValue(position.width)
      state.height = getUnitValue(position.height)
      state.left = getUnitValue(position.left)
      state.top = getUnitValue(position.top)
    }
    return {
      handleResizeDown,
      // showContextMenu,
      // handleClick,
      outDocFlow: true
    }
  }
})
